import React, { useState, useContext, useEffect } from 'react';

// MUI
import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
// Zustand
import useProjectStore from '../../ProjectCanvas/useProjectStore';
import { CanvasContext } from './WorkflowCanvas';
import ComponentTray from './SidebarItems/ComponentTray';

//css
import './Canvas.css';
import NotesTray from './SidebarItems/NotesTray';
import {
  ComponentMenuCanvasButton,
  NoteMenuCanvasButton,
} from '../../ProjectCanvas/Canvas/CanvasButtonsUtil/CanvasStyledComponents';

const styles = (theme) => ({
  buttons: {
    position: 'absolute',
    float: 'right',
    top: '50vh',
    transform: 'translate(-4px, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    right: '16px',
    zIndex: 1000,
  },
  trayButton: {
    position: 'absolute',
    float: 'right',
    top: '50vh',
    transform: 'translate(-4px, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    right: '400px',
    zIndex: 1000,
  },
  title: {
    fontFamily: 'Open Sans',
    lineHeight: 1,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    margin: 'auto',
  },
  description: {
    paddingTop: 4,
    fontFamily: 'Open Sans',
    lineHeight: 1,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    margin: 'auto',
    color: theme.palette.text.secondary,
  },
  search: {
    background: theme.palette.background.paper,
  },
  dropdown: {
    background: theme.palette.action.hover,
    color: theme.palette.text.primary,
    maxWidth: '100% !important',
    borderRadius: '8px',
    '& .MuiSelect-icon': {
      color: theme.palette.text.secondary,
    },
  },
  dropdownGrid: {
    maxWidth: '100% !important',
  },
  left: {
    alignSelf: 'flex-start!important',
    marginBottom: '8px !important',
  },
  logo: {
    height: '41px',
  },
  canvasItem: {
    boxShadow: 'unset!important',
    border: `1px solid ${theme.palette.divider} !important`,
    borderRadius: '8px !important',
    background: theme.palette.background.paper,
    padding: '12px',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      background: theme.palette.action.hover,
      cursor: 'pointer',
      transform: 'translateY(-2px) scale(1.01)',
    },
    '&:active': {
      transform: 'translateY(0) scale(0.98)',
    },
  },
});

const Sidebar = props => {
    const [showTray, setShowTray] = useState(false);
    const [showNotesTray, setShowNotesTray] = useState(false);

    //use react context to set canvas
    const { isCanvasLoaded, reactFlowInstance, workflowId } = useContext(CanvasContext);

    const componentTrayOpen = useProjectStore(s => s.componentTrayOpen);

    const [canvasLoaded, setCanvasLoaded] = isCanvasLoaded || [false, () => {}];
    const [rfInstance, setRfInstance] = reactFlowInstance || [null, () => {}];
    const { pendingConnectionSource: pendingConnectionSourceContext } = useContext(CanvasContext);
    const setPendingConnectionSource = pendingConnectionSourceContext
      ? pendingConnectionSourceContext[1]
      : null;

    const handleCloseComponentMenu = () => {
      setShowTray(false);
      setPendingConnectionSource(null);
    };

    useEffect(() => {
      if (componentTrayOpen) {
        openComponentMenu();
        useProjectStore.getState().resetComponentTrayTrigger();
      }
    }, [componentTrayOpen]);

    const openComponentMenu = () => {
      setShowTray(true);
      setShowNotesTray(false);
    };

    const openNoteMenu = () => {
      setShowNotesTray(true);
      setShowTray(false);
    };

    return (
      <>
        {!showTray && !showNotesTray && (
          <div className={props.classes.buttons}>
            <ComponentMenuCanvasButton
              onClick={() => {
                setShowTray(true);
              }}
            />
            <NoteMenuCanvasButton onClick={() => setShowNotesTray(true)} />
          </div>
        )}

        {showNotesTray && (
          <Grid container item direction={'row'} alignItems={'flex-end'}>
            <div className={props.classes.trayButton}>
              <ComponentMenuCanvasButton onClick={openComponentMenu} />
              <NoteMenuCanvasButton showClose onClick={() => setShowNotesTray(false)} />
            </div>
            <NotesTray classes={props.classes} onClose={() => setShowNotesTray(false)} />
          </Grid>
        )}

        {showTray && (
          <Grid container item direction={'row'} alignItems={'flex-end'}>
            <div className={props.classes.trayButton}>
              <ComponentMenuCanvasButton showClose onClick={handleCloseComponentMenu} />
              <NoteMenuCanvasButton onClick={openNoteMenu} />
            </div>
            <ComponentTray
              classes={props.classes}
              reactFlowInstance={rfInstance}
              workflowId={workflowId}
              onClose={handleCloseComponentMenu}
            />
          </Grid>
        )}
      </>
    );
};

export default withStyles(styles)(Sidebar);
